import { Injectable } from '@angular/core';

@Injectable()
export class SaveFilterStateService {

  private _query = '';
  private _active = '';
  private _state = '';
  private _installation_type = '';

  constructor() { }

  get query() {
    return this._query;
  }
  set query(value: string) {
    this._query = value;
  }

  get active() {
    return this._active;
  }
  set active(value) {
    this._active = value;
  }

  get state() {
    return this._state;
  }
  set state(value) {
    this._state = value;
  }

  get installation_type() {
    return this._installation_type;
  }
  set installation_type(value) {
    this._installation_type = value;
  }

  clear() {
    this.query = '';
    this.state = '';
    this.installation_type = '';
    this.active = '';
  }

  isDirty() {
    return (this.query !== '' || this.state !== '' || this.installation_type !== '' || this.active !== '');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/save-filter-state.service.ts